<script>
export default {
  components: {},
  data: () => {
    return {
      showItems: false,
    };
  },
  props: ["component", "handler"],
  methods: {
    itemsLength: function () {
      return Object.keys(this.component.items).length;
    },
  },
};
</script>

<template>
  <div>
    <div class="vprojector-card" @click="showItems = !showItems">
      <div class="icon">
        <f-icon icon="fg-all-in-one" figma></f-icon>
      </div>
      <div class="title">Others</div>
      <div class="list"></div>
      <div class="cost"></div>
      <f-button class="view" type="link"
        >View ({{ itemsLength() }}) <f-icon icon="arrow-right"></f-icon
      ></f-button>
    </div>
    <transition name="vprojector-items-fade">
      <div
        v-if="showItems"
        class="vprojector-items"
        @click="
          showItems = $event.target.classList.contains('vprojector-items')
            ? false
            : showItems
        "
      >
        <div class="goBack">
          <f-button type="icon tertiary overlay" @click.stop="showItems = false"
            ><f-icon icon="fa6-arrow-left"></f-icon
          ></f-button>
          Start a New Project
        </div>
        <div class="category">Others</div>
        <div class="items">
          <component
            v-for="(item, nid) in $options.filters.angularFilter(
              component.items,
              ['weight'],
              'orderObjectBy'
            )"
            :key="nid"
            v-bind:is="item.data.type"
            :component="item"
            :handler="handler"
          >
          </component>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.vprojector-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px 32px;
  width: 240px;
  height: 100%;
  min-height: 450px;
  background: var(--black);
  box-shadow: 0px 24px 32px -8px rgba(22, 21, 21, 0.5);
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background: var(--black-a75);
    box-shadow: 0px 24px 48px -8px rgba(22, 22, 21, 0.33);
  }

  &.pending {
    background: var(--black-a75);
    box-shadow: 0px 24px 48px -8px rgba(22, 22, 21, 0.33);
    outline: 4px solid rgba(24, 144, 211, 0.75);
  }

  .icon {
    width: 96px;
    height: 96px;
  }

  .title {
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: var(--white-a75);
  }

  &:hover .title,
  &.pending .title {
    color: color(--white);
  }

  .tag {
    margin-top: 8px;
    background: var(--white-a75);
    border-radius: 16px;
    padding: 4px 12px;

    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 125%;
    color: #ffffff;
  }

  .list {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .list-item {
      display: flex;
      font-family: Lato;
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 125%;
      color: var(--white-a75);

      .list-item-icon {
        margin-right: 10px;
        color: var(--primary);
      }
    }
  }

  .cost {
    margin-top: 16px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 125%;
    color: var(--white-a75);
  }

  .view {
    margin-top: 17px;
  }
}

.vprojector-items {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--white-a10);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1;

  > .goBack {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
    color: white;
    cursor: pointer;
  }

  > .category {
    margin-top: 13px;
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 58px;
    color: white;
  }

  > .items {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
  }
}

.vprojector-items-fade-enter-active {
  // transition: all 0.25s ease;
}
.vprojector-items-fade-enter,
.vprojector-items-fade-leave-to {
  opacity: 0;
}
</style>